import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent {
  @Input() enableTopGap: boolean = false;

  /** Exactly the navbar height (--nav-h), so no light strip shows between the bar and the page. */
  @HostBinding('style.marginTop') get marginTop() {
    return this.enableTopGap ? 'var(--nav-h, 75px)' : '0';
  }
}
